import { SaleBadge } from "@/components/billing/SaleBadge";
import { DEFAULT_ACCENT_COLOR } from "@/lib/accentColor";

/** One selectable plan card, shared by the subscribe dialog and the billing gate. */
export function PlanOption({
  label,
  price,
  originalPrice,
  subLabel,
  vatNote,
  badge,
  saleBadge,
  selected,
  onSelect,
}: {
  label: string;
  price: string;
  /** The regular price, shown struck through before `price` while a sale runs. */
  originalPrice?: string;
  subLabel: string;
  /** "+ VAT where applicable", shown under the price on every card. */
  vatNote: string;
  badge?: string;
  /** Gold sale pill. It replaces `badge` when both are set. */
  saleBadge?: string;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={`relative flex-1 rounded-xl border p-4 text-left transition-colors ${
        saleBadge ? "border-2 " : ""
      }${
        selected
          ? "border-primary bg-primary/5 ring-1 ring-primary"
          : "border-border hover:border-primary/40"
      }`}
      style={saleBadge ? { borderColor: DEFAULT_ACCENT_COLOR } : undefined}
    >
      <p className="text-xs font-bold uppercase tracking-[0.1em] text-muted-foreground mb-1">
        {label}
      </p>
      <p className="text-2xl font-bold tracking-tight text-foreground">
        {originalPrice && (
          <s className="mr-1.5 text-base font-medium text-muted-foreground">
            {originalPrice}
          </s>
        )}
        {price}
        {/* Points to the sale footnote under the cards. */}
        {saleBadge && <span aria-hidden="true">*</span>}
      </p>
      <p className="text-xs text-muted-foreground mt-1">{subLabel}</p>
      <p className="text-xs text-muted-foreground mt-0.5">{vatNote}</p>
      {/* Last in the DOM so the card's accessible name still starts with its label. */}
      {saleBadge ? (
        <SaleBadge className="absolute -top-3 right-3">{saleBadge}</SaleBadge>
      ) : (
        badge && (
          <span className="absolute -top-2.5 right-3 text-[10px] font-semibold text-emerald-700 bg-emerald-100 px-1.5 py-0.5 rounded-full">
            {badge}
          </span>
        )
      )}
    </button>
  );
}
